import NotificationInformation from '@/components/Notifications/NotificationInformation'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

const NoEvents = () => {
    const { t } = useTranslation('dashboard')

    return (
        <div className="flex flex-col gap-2 items-center justify-center h-full">
            <div className="flex w-full flex-col items-center justify-center px-2 py-4 bg-[#FAFAFA] rounded-lg">
                <Typogaphy className="text-[#858585] font-medium text-center mb-2">
                    {t('events.no_data_today')}
                </Typogaphy>
                {}
                <Typogaphy className="text-[#858585] text-center">
                    {t('events.no_data_today_description')}
                </Typogaphy>
            </div>
            <NotificationInformation
                title={t('events.notification_information', {
                    event_type: t('events.my_events'),
                })}
            />
        </div>
    )
}

export default NoEvents
